export default {
  // api_url: '/static/json',               // 本地
  api_url: '',                              // 线上代理
  url_baseURL: '//img.webloom.cn/',         // 图片地址前缀
  // return_url: '//test.webloom.cn/competition/NEC'           // 模拟赛返回地址 测试服的
  return_url: '/competition/NEC'           // 模拟赛返回地址 测试服的
  // return_url: '//www.webloom.cn/competition/NEC',        // 模拟赛返回地址 正式服的
}



// WEBPACK FOOTER //
// ./src/assets/config/index.js